<template>
	<div class="login-wrap">
		<van-icon class="back" @click="back" name="arrow-left" size="24"></van-icon>
		<div class="login-title">短信验证码</div>
		<van-password-input
		  :value="value"
			:length="4"
		  info="请输入手机验证码"
		  @focus="showKeyboard = true"
			@blur="showKeyboard = false"
		/>
		<van-number-keyboard
		  :show="showKeyboard"
		  @input="onInput"
		  @delete="onDelete"
		  @blur="showKeyboard = false"
		/>
		<!-- <div class="bottom">
			<div class="provider">
				<span>微信登录</span>
				<img src="../assets/images/wx.png" alt="">
			</div>
			<div class="protocal">
				阅读<span class="detail">《用户协议与隐私政策》</span>
			</div>
		</div> -->
	</div>
</template>

<script>
	import {Toast} from 'vant'
	export default {
		name: 'AccoutLogin',
		data() {
			return {
				value: '',
				showKeyboard: false,
				isSending: false
			}
		},
		methods: {
			onInput(key) {
				this.value = (this.value + key).slice(0, 4);
				if (this.value.length == 4) {
					this.$api.post('CheckSmsLogin', {
						phone: this.$route.query.phone,
						code: this.value
					}).then(res => {
						if (res.resultCode == 0) {
							// 如果是在手机环境
							if (typeof plus != "undefined") {
								uni.reLaunch({
									url: `../main/main?token=${res.access_token}&operator=${res.user_id}`
								})
								
							// 如果是本地调试
							} else {
								localStorage.setItem('token', res.access_token)
								localStorage.setItem('operator', res.user_id)
								this.$router.push('home')
							}
						} else {
							Toast(res.resultMessage)
						}
					})
				}
			},
			onDelete() {
				this.value = this.value.slice(0, this.value.length - 1);
			},
			back() {
				this.$router.goBack()
			}
		}
	}
</script>

<style lang="less" scoped>
	.login-wrap {
		font-size: 16px;
		.back {
			margin: 20px;
		}
	}
	.input-wrap {
		margin: 24px;
		border-bottom: 1px solid #f1f1f1;
		padding: 6px 0;
		.van-field__label{
			width: 50px;
			color: #666666;
		}
		.input {
			padding: 6px 0;
		}
	}
	.login-title {
		font-size: 24px;
		margin: 20px;
		margin-top: 40px;
	}
	.dict {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.login-button {
		margin: 0 24px;
		.van-button--disabled {
			opacity: 1;
			border: 1px solid #acacac;
			background-color: #acacac;
		}
	}
	
	.login-methods {
		padding: 10px 24px;
		font-size: 12px;
		color: #6a6a6a;
	}
	.bottom {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 120px;
		.provider {
			display: flex;
			flex-direction: column;
			align-items: center;
			color: #6a6a6a;
			img {
				width: 50px;
				height: 50px;
				margin-top: 4px;
			}
		}
		.protocal {
			margin-top: 10px;
			display: flex;
			justify-content: center;
			font-size: 12px;
			color: #6a6a6a;
			.detail {
				margin-left: 2px;
				color: #1989fa;
				font-size: 12px;
			}
		}
	}
</style>
